import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

export type NotificationType = 'all' | null;

@Injectable({
  providedIn: 'root',
})
export class NotificationsPanelService {
  public openNotifications = new BehaviorSubject<NotificationType>(null);
  public openNotifications$ = this.openNotifications.asObservable();

  public onOpenNotifications(open: NotificationType): void {
    this.openNotifications.next(open);
  }
}
